import './style.scss';
import { UserPost } from '../../types/posts';
import { PAGE_URLS } from '../../constants/hrefLinks';
import { useState } from 'react';
import { postConnector } from '../../server/connector/postConnector';
import { userStateData } from '../../data/userStateData';
import { useAppDispatch } from '../../redux/hooks';
import { setCommentPost } from '../../redux/reducers/postSlice';

interface AppUserPostProps {
	data: UserPost,
	disableInteraction?: boolean | undefined
}

function AppUserPost({data, disableInteraction}: AppUserPostProps) {
	const dispatch = useAppDispatch()

	const minsAgo: number = Math.floor((new Date().getTime() - Number(data.postDate)) / 1000 / 60)
	const hoursAgo: number = Math.floor(minsAgo / 60)
	const daysAgo: number = Math.floor(hoursAgo / 24)

	const [postLikeCount, setPostLikeCount] = useState<number>(data.likeCount ? parseInt(data.likeCount) : 0)
	const [postLiked, setPostLiked] = useState<boolean>(userStateData.likesPostIds.includes(data.postId))
	const [likingPost, setLikingPost] = useState<boolean>(false)

	const postLikeClickHandler = () => {
		if (!disableInteraction) {
			setLikingPost(true)
			if (data.postId) {
				if (postLiked == false && likingPost == false) {
					postConnector.likePostRequest(data.postId, userStateData.getId()).then((successResponse) => {
						if (successResponse) {
							setPostLikeCount(postLikeCount + 1)
							setPostLiked(true)
						}
						setLikingPost(false)
					})
				} else {
					postConnector.unlikePostRequest(data.postId, userStateData.getId()).then((successResponse) => {
						if (successResponse) {
							setPostLikeCount(postLikeCount - 1)
							setPostLiked(false)
						}
						setLikingPost(false)
					})
				}
			}
		}
	}

	const commentClickHandler = () => {
		dispatch(setCommentPost(data))
	}
	
	return (
		<div className='app-user-post-wrap'>
			<div className='app-user-post-details-wrap'>
				<img 
					className='app-user-post-profile-img'
					src={data.sourceImgSrc}
					alt='Posters Profile'
					onClick={() => {
						window.location.replace(`${PAGE_URLS.APP_PROFILE_USER}?id=${data.sourceUserId}`)
					}}
				/>
				<div className='app-user-post-info'>
					<a 
						className='app-user-post-name'
						href={`${PAGE_URLS.APP_PROFILE_USER}?id=${data.sourceUserId}`}
						aria-label={`Visit the profile page for User ${data.sourceUserId}`}
					>
						{data.sourceName.replace(' ', '.').toLowerCase()}
						{data.verified && 
							<img
								className='app-user-post-verify-tick'
								src='/imgs/icons/profile/icon-profile-verified-tick.svg'
								alt='Verified tick'
							/>
						}
					</a>
					<div className='app-user-post-time'>
						{daysAgo > 0 ? `${daysAgo} days ` : hoursAgo > 0 ? `${hoursAgo} hours ` : `${minsAgo} mins `} 
						ago | <a 
							href={`${PAGE_URLS.APP_COMMUNITY}?id=${data.community_id}`}
							aria-label={`Visit the profile page for Community ${data.community}`}
							className='app-user-post-community'
						>{data.community}</a>
					</div>
				</div>
			</div>
			<div className='app-user-post-content-wrap'>
				{data.postMsg}
			</div>
			{data.postImgSrc && 
				<div className='app-user-post-content-wrap'>
					<img
						className='app-user-post-img'
						src={data.postImgSrc}
						alt={`post_img_${data.postId}`}
					/>
				</div>
			}
			<div className='app-user-post-interaction-wrap'>
				<img
					className='app-user-post-interaction-icon'
					src={postLiked ? '/imgs/icons/posts/icon-post-liked.svg' : '/imgs/icons/posts/icon-post-like.svg'}
					alt='Post Like Button'
					onClick={() => {
						postLikeClickHandler()
					}}
				/>
				<div className='app-user-post-interaction-number'>{postLikeCount}</div>
				<img
					className='app-user-post-interaction-icon'
					src='/imgs/icons/posts/icon-post-comment.svg'
					alt='Post Comment Button'
					onClick={() => {
						commentClickHandler()
					}}
				/>
				<div className='app-user-post-interaction-number'>{data.commentCount ? data.commentCount : '0'}</div>
			</div>
		</div>
	)
}

export default AppUserPost
